module.exports = __webpack_public_path__ + "img/tracking-removebg-preview (3).01152774.png";